export default __webpack_public_path__ + "static/media/candidateSample.02fa274a.xlsx";